import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <p>Powered By: Eruna Technologies</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default React.memo(Footer);
